import React from 'react';

const withDefaultPropsHOCGenerator = (Component) => {
  function WithDefaultPropsHOC(props) {
    return <Component {...props} />;
  }

  WithDefaultPropsHOC.defaultProps = {
    minSymbolsToStart: 3,
    stopWords: [' '],
    onSelectPreProcessor: (selected) => selected,
    groupBy: null,
    highlight: false,
  };

  return WithDefaultPropsHOC;
};

const withDefaultProps = () => (Component) => withDefaultPropsHOCGenerator(Component);

export default withDefaultProps;
